
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5 3"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h5v3H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#0065BD","d":"M0 0h50v30H0z"}}),_c('path',{attrs:{"d":"M0 0l5 3M0 3l5-3","fill":"none","stroke":"#fff","stroke-width":".6"}})])])
          )
        }
      }
    